import ProductTasksTable from './components/product-tasks-table/ProductTasksTable';

const ProductTasksTab = (): JSX.Element => {
  return (
    <div className='flex flex-column'>
      <ProductTasksTable />
    </div>
  );
};

export default ProductTasksTab;
